export const AGENDA = "/agenda";
export const GAGENDA = "/gagenda";
